import Avatar from "@material-ui/core/Avatar";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Skeleton from "@material-ui/lab/Skeleton";

import React from "react";

import Props from "@sentrei/common/types/components/SpaceScreen";
import Loader from "@sentrei/ui/components/Loader";

import SpaceScreenStyles from "./SpaceScreenStyles";

export default function SpaceScreen({space, members}: Props): JSX.Element {
  const classes = SpaceScreenStyles();

  if (!space) {
    return <Loader />;
  }

  return (
    <div>
      <Container maxWidth="md" component="main">
        <Grid
          container
          alignItems="center"
          alignContent="center"
          direction="column"
          justify="center"
          spacing={3}
          className={classes.grid}
        >
          <Grid item xs={12} sm={6}>
            <Avatar
              alt="Space"
              src={space.photo || undefined}
              className={classes.large}
            />
            <Typography
              variant="h4"
              align="center"
              color="textSecondary"
              component="h5"
            >
              {space.id}
            </Typography>
            <Typography>Members</Typography>
            {members ? (
              <AvatarGroup max={3}>
                {members.map(member => (
                  <Avatar
                    key={member.username}
                    src={member.photo || undefined}
                  />
                ))}
              </AvatarGroup>
            ) : (
              <Skeleton>
                <AvatarGroup max={3}>
                  <Avatar />
                  <Avatar />
                  <Avatar />
                </AvatarGroup>
              </Skeleton>
            )}
          </Grid>
          )
        </Grid>
      </Container>
    </div>
  );
}
